import { ReactElement } from 'react'
import styled from 'styled-components'
import { Translate2 } from 'common'

interface ResultsCountLabelProps {
  count: number
  searchTerm: string
  isLoading: boolean
}

export const ResultsCountLabel = ({
  count,
  searchTerm,
  isLoading,
}: ResultsCountLabelProps): ReactElement => {
  if (isLoading) {
    return <Wrapper aria-busy="true" />
  }

  return (
    <Wrapper aria-live="polite">
      <Count>{count}</Count>
      <ResultsWord>{Translate2('results')}</ResultsWord>
      {searchTerm ? (
        <>
          <ForWord>{Translate2('for')}</ForWord>
          <QuotedTerm>&quot;{searchTerm}&quot;</QuotedTerm>
        </>
      ) : null}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35em;
  font-family: Roboto, serif;
  font-size: 16px;
  line-height: 24px;
  color: ${(p) => p.theme.colors.text};
  padding: 12px 0;
`

const Count = styled.span`
  font-family: Oswald, serif;
  font-weight: bold;
  font-size: 24px;
  line-height: 34px;
  color: ${(p) => p.theme.colors.black};
`

const ResultsWord = styled.span`
  font-family: Oswald, serif;
  font-weight: bold;
  font-size: 24px;
  line-height: 34px;
  text-transform: uppercase;
  color: ${(p) => p.theme.colors.black};
`

const ForWord = styled.span`
  font-weight: 400;
`

const QuotedTerm = styled.span`
  font-weight: 400;
`
